import { css } from "@emotion/react";
import { CheckoutForm } from "../components/CheckoutForm/CheckoutForm";
import { CustomScrollbars } from "../components/CustomScrollbars/CustomScrollbars";
import { SiteLayout } from "../components/SiteLayout";
import { AppConstants } from "../data/AppConstants";
import { useCheckoutFormState } from "../hooks/useCheckoutFormState";
import { useTranslate } from "../hooks/useTranslate/useTranslate";

export const CheckoutPage = () => {
	const quoteRequestFormState = useCheckoutFormState();
	const translate = useTranslate();

	return (
		<SiteLayout
			title={translate("Checkout")}
			mainChildren={
				<CustomScrollbars className="flex-1 overflow-y-auto">
					<div
						className="mx-auto flex w-full justify-center px-4 py-4 sm:px-6 sm:py-6"
						css={css`
							max-width:${AppConstants.siteWidthCss};
							align-items:flex-start;
						`}
					>
						<CheckoutForm checkoutFormState={quoteRequestFormState} />
					</div>
				</CustomScrollbars>
			}
		/>
	);
};
